import React from 'react';
import Skeleton from '@srm/ui/skeleton';

const MatrixSkeleton: React.FC = () => (
    <>
        <div className="ws2-loading-caption" role="status">
            Загружаем лоты и предложения…
        </div>
        <div className="ws2-viewport ws2-viewport--loading" aria-busy="true" aria-label="Загрузка матрицы">
            <div className="ws2-skeleton" aria-hidden="true">
                <div className="ws2-skeleton__row ws2-skeleton__row--head">
                    {[0, 1, 2].map((column) => (
                        <div className="ws2-skeleton__cell" key={column}>
                            <Skeleton height={16} width="65%" />
                            <Skeleton height={10} width="45%" />
                        </div>
                    ))}
                </div>
                <div className="ws2-skeleton__lot">
                    <Skeleton height={14} width={180} />
                </div>
                {[0, 1, 2].map((row) => (
                    <div className="ws2-skeleton__row" key={row}>
                        {[0, 1, 2].map((column) => (
                            <div className="ws2-skeleton__cell" key={column}>
                                <Skeleton height={16} width={column === 0 ? '80%' : '45%'} />
                                <Skeleton height={10} width="55%" />
                                <Skeleton height={10} width="35%" />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    </>
);

export default MatrixSkeleton;
